import { render } from "./NameCertifyPopUp.vue?vue&type=template&id=7515ab01"
import script from "./NameCertifyPopUp.vue?vue&type=script&lang=js"
export * from "./NameCertifyPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__